import { UserDataService } from './../../../core/services/user-data.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { RouteStateService } from '../../../core/services/route-state.service';
import { UserReg } from '../../../core/models/Other/UserReg'
import { notification } from '../../../core/models/notification.model';
import { ThemeService } from '../../../core/services/theme.service';
import { UserContextService } from '../../../core/services/user-context.service';
//import { CookieService } from 'ngx-cookie-service';
import { CommonService } from 'src/app/core/services/common.service';
import { Params4Post } from 'src/app/core/models/General/Params4Post';
import { ReuseTabService } from 'src/app/core/reuse-tab';
import { CompanyInforService } from 'src/app/SmartBook.SetupTools/CompanyInfor/company_infor.service';
//import { MenuDataService } from 'src/app/core/services/menu-data.service';
//import { saveAs } from 'file-saver';
import { ToastService } from 'src/app/core/services/toast.service';
import { ApplicationStateService } from 'src/app/core/services/application-state.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { CompanyInfor } from 'src/app/core/models/Other/SetupTools/CompanyInfor';
import { ConfirmationService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [MessageService, ConfirmationService, DatePipe],

})
export class HeaderComponent implements OnInit {
  locale: string;
  language: any;
  user: UserReg;
  companyInformation: CompanyInfor = new CompanyInfor();
  company: string = "";
  displayNotifications: boolean;
  queryExcel: boolean = false;
  query: string;
  timeout: number = 30;

  notifications: notification[];
  showUnrelease = false;
  showImport = false;
  showCP = false;
  showInventoryConfig = false;
  companyCode = "";
  headerMobile: boolean = false;

  displayLicense: boolean = false;
  expiryDate: Date;
  expiryDateDays: number;

  money: any;
  money_value = 1000000;
  dropdownYear: any[];
  year: number;
  oldYear: number;

  dropdownInventory: any[];
  configIn = "0";

  @Output() toggleMenubar: EventEmitter<any> = new EventEmitter();

  constructor(
    public translate: TranslateService,
    private router: Router,
    private routeStateService: RouteStateService,
    private themeService: ThemeService,
    private userContextService: UserContextService,
    //private cookieService: CookieService,
    private userDataService: UserDataService,
    public commonService: CommonService,
    private reuseTabService: ReuseTabService,
    private companyInfor: CompanyInforService,
    //private menuDataService: MenuDataService,
    private toastService: ToastService,
    private applicationStateService: ApplicationStateService,
    private localStorageService: LocalStorageService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
    private messageService: MessageService,

    ) {
      try {
        if(this.applicationStateService.getIsMobileResolution()){
          this.headerMobile = true;
        }
        else{
          this.headerMobile = false;
        }
        
        this.displayNotifications = false;
    
        let selectedTheme = this.localStorageService.getItem("selected-theme");
        if (selectedTheme) {
          this.selectTheme(selectedTheme);
        }
        this.locale = this.localStorageService.getItem("language");
        this.money_value = this.localStorageService.getItem("sl_currency") ? this.localStorageService.getItem("sl_currency") : 1000000;
    
        this.language = [
          { label: 'English', value: 'EN' },
          { label: 'Vietnamese (Tiếng Việt)', value: 'VN' },
          { label: 'Korean (한국어)', value: 'KR' },
          { label: 'Japanese (漢字)', value: 'JP' },
          { label: 'Chinese (汉语)', value: 'CN' },
          { label: 'Khmer (ភាសាខ្មែរ)', value: 'KH' },
        ];
        this.dropdownInventory = [
          { label: 'MainMenu.InventoryConfig', value: '0' },
          { label: 'MainMenu.CostConfig', value: '1' },
          { label: 'MainMenu.CostingRateAllocationGroup', value: '2' },
          { label: 'MainMenu.CostingRateAllocationProduct', value: '3' },
          { label: 'MainMenu.CostingCenterGroupUsing', value: '4' },
          { label: 'MainMenu.CalculateQty154ForEachProduct', value: '5' },
          { label: 'MainMenu.CostingRateAllocationGroupSpecial', value: '6' },
          { label: 'MainMenu.CostingRateAllocationProductSpecial', value: '7' },
          { label: 'MainMenu.Norms', value: '8' },
        ];
        this.money = [
          { label: 'Million VND', value: 1000000 },
          { label: 'VND', value: 1 },
          { label: 'USD~23000', value: 23000 },
        ];
        if(this.localStorageService.getItem("AccessFoGL").indexOf("/main/gl/unrelease") > -1) this.showUnrelease = true;
        if(this.localStorageService.getItem("AccessFoSI").indexOf("/main/general/import_tool") > -1) this.showImport = true;
        if(this.localStorageService.getItem("AccessModule").includes("CP") > -1) this.showCP = true;
        if(this.localStorageService.getItem("AccessModule").includes("IN") > -1) this.showInventoryConfig = true;
    
        let ye = new Date().getFullYear();
        this.dropdownYear = [
          { label: "Customer Portal in: " + ye.toString(), value: ye },
        ];
        for(let i = 1; i <= 10; i ++){
          this.dropdownYear.push({label: "Customer Portal in: " + (ye-i).toString(), value: ye-i});
        }
        this.year = this.localStorageService.getItem("YearCP");
        this.oldYear = this.year;
      } catch (error) {
        console.log(error);
      }
  }

  ngOnInit() {
    this.companyInfor.getCompanyInfor()
      .subscribe((responseResult: any) => {
        this.companyInformation = responseResult.Data;
        this.company = this.companyInformation.CpnyName + " - Fiscal Year : " + this.companyInformation.FiscalYear;
      });
    this.user = this.userContextService.user$.getValue();
    this.notifications = [];
    for (let i = 1; i <= 5; i++) {
      let notificationObj = new notification("Message " + i, new Date(), null)
      this.notifications.push(notificationObj);
    }
    this.companyCode = this.localStorageService.getItem("cpnc");

    this.expiryDateDays = this.localStorageService.getItem("lic");
    this.expiryDate = new Date();
    this.expiryDate.setDate(this.expiryDate.getDate() + Number(this.expiryDateDays));
    if(Number(this.expiryDateDays) < 30){
      this.displayLicense = true;
    }
    if(this.showCP){
      if(this.localStorageService.getItem("UpdateCPFisrt") == "1"){
        this.commonService.showSuccess(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu đang được cập nhật ..." : "Data is updating ...");
        this.commonService.getDataParams("api/cp/update_data",[["year",""]]).subscribe((responseResult: any) => {
          if (responseResult.Data) {
            this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
            this.localStorageService.setItem("UpdateCPFisrt", "0");
            this.confirmationService.confirm({
              key: "cp",
              message: this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật thành công!" 
                : "Customer Portal Data updated successfully!",
              header: "Success",
              icon: 'far fa-check-square',
              accept: () => {},
              reject: () => {
              }
            });
            this.commonService.showSuccess(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật thành công!" : "Customer Portal Data updated successfully!");
          }
          else{
            // this.commonService.showErrorLife(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật không thành công!" : "Customer Portal Data updated not successfully!",100000);
            this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
            this.localStorageService.setItem("UpdateCPFisrt", "0");
            // this.confirmationService.confirm({
            //   key: "cp",
            //   message: responseResult.Message,
            //   header: "Fail",
            //   icon: 'pi pi-exclamation-triangle',
            //   accept: () => {},
            //   reject: () => {
            //   }
            // });
            // this.commonService.showError(this.messageService, responseResult.Message);
          }
        },
        err => {
            this.commonService.showErrorRequest(this.messageService);
    
        },
        () =>{
        });
      }
      
      //   {
    //     "RowError": "",
    //     "RowState": 2,
    //     "Table": [
    //         {
    //             "CliID": 563,
    //             "ClientID": 403,
    //             "CliCode": "[SERVERSS\\SSHN].DEMOWEB",
    //             "ServerName": "SERVERSS\\SSHN",
    //             "DatabaseName": "DEMOWEB",
    //             "ImportCommand": "ss_importDatabase",
    //             "Note": null,
    //             "last_user_update": "2023-03-13T16:59:10.12",
    //             "company_code": "",
    //             "Deleted": false
    //         }
    //     ],
    //     "ItemArray": [
    //         563,
    //         403,
    //         "[SERVERSS\\SSHN].DEMOWEB",
    //         "SERVERSS\\SSHN",
    //         "DEMOWEB",
    //         "ss_importDatabase",
    //         null,
    //         "2023-03-13T16:59:10.12",
    //         "",
    //         false
    //     ],
    //     "HasErrors": false
    // }

    }
  }

  checkLic(){
    //Start watching for user inactivity.
    if(Number(this.expiryDateDays) <= 1){
      setTimeout(()=>{
        this.displayLicense = true;
        }, 5000);
    }
    else if(Number(this.expiryDateDays) < 5){
      setTimeout(()=>{
        this.displayLicense = true;
        }, 300000);
    }
    else{
      setTimeout(()=>{
        this.displayLicense = true;
      }, 1500000);
    }
  }

  hideDialogLic(){
    this.checkLic();
  }

  async logout() {
    // this.userIdle.stopWatching();
    this.userDataService.logout().subscribe((responseResult: any) => {
      if (responseResult.Data == true) {
        return;
      }
    });
    this.routeStateService.removeAll();
    this.userContextService.logout();
    // this.localStorageService.removeItem('active-menu');
    // this.localStorageService.removeItem("currentUser");
    // this.localStorageService.removeItem("language");
    // this.localStorageService.removeItem("selected-theme");
    // this.localStorageService.removeItem("selected-theme");
    this.localStorageService.clear();
    this.reuseTabService.clear();
    this.localStorageService.setItem("language", this.locale);
    this.router.navigate(['/login']);
  }

  showNotificationSidebar() {
    this.displayNotifications = true;
  }

  toggleMenu() {
    this.toggleMenubar.emit();
  }

  selectTheme(theme: string) {
    this.localStorageService.setItem("selected-theme", theme);
    this.themeService.selectTheme(theme);
  }
  onMoneyChange(){
    this.localStorageService.setItem("sl_currency", this.money_value);
    window.location.reload();
  }

  configInventory(type: string){
    let link = "";
    switch (type) {
      case '1': link ='/main/inventory/setup_inventory/cost_config'; break;
      case '2': link ='/main/inventory/setup_inventory/costing_rate_allocation_group'; break;
      case '3': link ='/main/inventory/setup_inventory/costing_rate_allocation_product'; break;
      case '4': link ='/main/inventory/setup_inventory/costing_center_group_using'; break;
      case '5': link ='/main/inventory/setup_inventory/cal_tot_qty_for_each_product'; break;
      case '6': link ='/main/inventory/setup_inventory/costing_rate_alloc_group_spec'; break;
      case '7': link ='/main/inventory/setup_inventory/costing_rate_alloc_product_spec'; break;
      case '8': link ='/main/inventory/setup_inventory/ic_norms'; break;

    };
    this.dropdownInventory = [...this.dropdownInventory];
    if(link)
      this.router.navigate([link]);
  }

  onLanguageChange() {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(this.locale);
    this.localStorageService.setItem("language", this.locale);
    this.changLanguageCookies();
  }
  changLanguageCookies() {
    this.commonService.getDataWithPost("api/general/ChangeLanguage", new Params4Post(this.locale)).toPromise().then((res: any) => {
    });
  }
  importTool() {
    this.router.navigate(['/main/general/import_tool']);
  }
  unRelease() {
    this.router.navigate(['/main/gl/unrelease']);
  }
  deleteImportList() {
    this.router.navigate(['/main/general/delete_import_list']);
  }
  deleteBatchList() {
    this.router.navigate(['/main/general/delete_batch']);
  }
  salaryHRTranfer(){
    this.router.navigate(['/main/general/salary_hr_tranfer']);
  }
  closeAllWindows() {
    this.reuseTabService.clear();
  }
  refreshCustomerPortal() {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    let lastUpdateCPTime;
    if (this.localStorageService.getItem("LastUpdateCP")) lastUpdateCPTime = Date.parse(this.localStorageService.getItem("LastUpdateCP"));
    else lastUpdateCPTime = date;
    let lastUpdateCPTimeString = this.datePipe.transform(lastUpdateCPTime, "dd-MM-yyyy | HH:mm");
    this.confirmationService.confirm({
      key: "common",
      message: this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng hiện tại được cập nhật mới nhất vào lúc: " + lastUpdateCPTimeString + ". Bạn có muốn cập nhật lại số liệu ngay bây giờ?" 
        : "Current Customer Portal Data was last updated at: " + lastUpdateCPTimeString + ". Do you want to update the data now?",
      header: this.commonService.getLanguage() == "VN" ? "Cập nhật số liệu Cổng khách hàng" : "Update Customer Portal Data",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.commonService.showSuccess(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu đang được cập nhật ..." : "Data is updating ...");
        this.commonService.getDataParams("api/cp/update_data",[["year",this.year.toString()]]).subscribe((responseResult: any) => {
          if (responseResult.Data) {
            this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
            this.confirmationService.confirm({
              key: "cp",
              message: this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật thành công!" 
                : "Customer Portal Data updated successfully!",
              header: "Success",
              icon: 'far fa-check-square',
              accept: () => {},
              reject: () => {
              }
            });
            this.commonService.showSuccess(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật thành công!" : "Customer Portal Data updated successfully!");
          }
          else{
            // this.commonService.showErrorLife(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật không thành công!" : "Customer Portal Data updated not successfully!",100000);
            this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
            // this.confirmationService.confirm({
            //   key: "cp",
            //   message: responseResult.Message,
            //   header: "Fail",
            //   icon: 'pi pi-exclamation-triangle',
            //   accept: () => {},
            //   reject: () => {
            //   }
            // });
            // this.commonService.showError(this.messageService, responseResult.Message);
          }
        },
        err => {
            this.commonService.showErrorRequest(this.messageService);

        },
        () =>{
        });
      },
      reject: () => {
      }
    });
  }

  yearChange() {
    this.confirmationService.confirm({
        key: "common",
        message: this.commonService.getLanguage() == "VN" ? "Dữ liệu cổng khách hàng sẽ được cập nhật theo năm: " + this.year.toString() + ". Bạn có muốn cập nhật lại số liệu ngay bây giờ?" 
            : "Customer portal data will be updated in: " + this.year.toString() + ". Do you want to update the data now?",
        header: this.commonService.getLanguage() == "VN" ? "Cập nhật số liệu Cổng khách hàng" : "Update Customer Portal Data",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.commonService.showSuccessLife(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu đang được cập nhật ... Vui lòng đợi cho tới khi có thông báo để có thể xem dữ liệu chính xác." : "The data is being updated... Please wait until the announcement to see the correct data.", 70000);
            this.commonService.getDataParams("api/cp/update_data",[["year",this.year.toString()]]).subscribe((responseResult: any) => {
                if (responseResult.Data) {
                    this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
                    this.localStorageService.setItem("YearCP", this.year);
                    this.oldYear = this.year;
                    this.confirmationService.confirm({
                    key: "cp",
                    message: this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật thành công!" 
                        : "Customer Portal Data updated successfully!",
                    header: "Success",
                    icon: 'far fa-check-square',
                    accept: () => {window.location.reload();},
                    reject: () => {
                    }
                    });
                }
                else{
                    // this.commonService.showErrorLife(this.messageService, this.commonService.getLanguage() == "VN" ? "Dữ liệu Cổng khách hàng được cập nhật không thành công!" : "Customer Portal Data updated not successfully!",100000);
                    this.localStorageService.setItem("LastUpdateCP", responseResult.Data1.Table[0]["last_user_update"]);
                    this.year = this.oldYear;
                    this.localStorageService.setItem("YearCP", this.year);
                    this.oldYear = this.year;

                    // this.confirmationService.confirm({
                    // key: "cp",
                    // message: responseResult.Message,
                    // header: "Fail",
                    // icon: 'pi pi-exclamation-triangle',
                    // accept: () => {},
                    // reject: () => {
                    // }
                    // });
                    // this.commonService.showError(this.messageService, responseResult.Message);
                }
                },
                err => {
                    this.commonService.showErrorRequest(this.messageService);

                },
                () =>{
                });
        },
        reject: () => {
            this.year = this.oldYear;
            this.localStorageService.setItem("YearCP", this.year);
            this.oldYear = this.year;
        }
    });
  }
  query2Excel() {
    this.queryExcel = true;
  }
  clickExport(){
    if(this.query == null || this.query.trim() == ''){
      this.toastService.addSingle('error', '', 'Entry Query');
      this.commonService.focusInput("query");
    }
    else if(this.timeout == null || this.timeout < 30){
      this.toastService.addSingle('error', '', 'Timeout should be greater than 30s to ensure request time');
      this.commonService.focusInput("timeout");
    }
    else{
    //   let param : Params4Post = new Params4Post(this.query, this.timeout.toString());
    //   this.commonService.downloadExcel(param,"api/gl/export-excel/query2excel").subscribe(res => {
    //     const data = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     saveAs(data,"data");
    //     this.queryExcel = false;
    //   },err => {
    //     this.toastService.addSingle('error', '', "Query không hợp lệ hoặc yêu cầu tới máy chủ bị lỗi")
    //     this.commonService.showError(this.messageService, err)
    // });
    }
  }
  restore(){
    this.commonService.getData("api/restore_default").subscribe((responseResult: any) => {
      if(responseResult.Data == true){
        this.toastService.addSingle('success', '', "Khôi phục dữ liệu thành công");
      }
      else{
        this.toastService.addSingle('error', '', responseResult.Message);
      }
      },err => {
          this.toastService.addSingle('error', '', "Yêu cầu tới máy chủ bị lỗi")
      });
  }
  guildLine(){
    let url = this.commonService.getUrlCurrent();
    let language = this.localStorageService.getItem("language");
    if(url == "/main/dashboard"){
      if(language == "VN"){
        window.open('https://docs.ssaudit.com/','_blank')
      }
      else if(language == "KR"){
        window.open('https://docs.ssaudit.com/v/korean-2/','_blank')
      }
      else{
        window.open('https://docs.ssaudit.com/v/english-2/','_blank')
      }
    }
    else if(url.includes("/main/gl/")){
      if(url == "/main/gl/account_list"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/danh-muc-tai-khoan','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
      }
      else if(url == "/main/gl/acct_class"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/danh-muc-nhom-tai-khoan','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
      }
      else if(url == "/main/gl/setup_bs" || url == "/main/gl/glbs_description" || url == "/main/gl/glbs_code2" || url == "/main/gl/glbs_code1"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/thiet-lap-bang-can-doi-ke-toan','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
      }
      else if(url == "/main/gl/glpost_description"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/thiet-lap-tai-khoan-but-toan-ket-chuyen-set-up/khai-bao-but-toan-ket-chuyen-so-du-tai-khoan','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/set-up-an-account-do-accounting-transfer-set-up','_blank')
        }
      }
      else if(url == "/main/gl/gl_tran" || url == "/main/gl/journal_tran_old"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/nhap-du-lieu-input','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/data-input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/data-input','_blank')
        }
      }
      else if(url == "/main/gl/closing_period" || url == "/main/gl/unrelease" || url == "/main/gl/closing_by_month"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/xu-ly-du-lieu-proccess','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/data-processing','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/data-processing','_blank')
        }
      }
      else if(url == "/main/gl/gl_inquiry"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/chi-tiet-hach-toan-inquiry','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/inquiry','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/inquiry','_blank')
        }
      }
      else if(url.includes("/main/gl/report_gl")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/ket-xuat-bao-cao-reports','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/general-ledger/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/general-ledger/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/ap/")){
      if(url == "/main/ap/vendor_list"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account_payable/danh-muc-nha-cung-cap','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/account-payable/set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/account-payable/set-up','_blank')
        }
      }
      else if(url == "/main/ap/apvoucher"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account_payable/nhap-lieu-hoa-don-nha-cung-cap','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/account-payable/input-invoice-of-vendors','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/account-payable/input-invoice-of-vendors','_blank')
        }
      }
      else if(url == "/main/ap/ap_release_batches"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account_payable/xu-ly-nhieu-chung-tu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/account-payable/proccess-ap-release-batches','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/account-payable/proccess-ap-release-batches','_blank')
        }
      }
      else if(url == "/main/ap/ap_inquiry"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account_payable/chi-tiet-hach-toan-phai-tra','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/account-payable/inquiry','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/account-payable/inquiry','_blank')
        }
      }
      else if(url.includes("/main/ap/report_ap")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account_payable/bao-cao-reports','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/account-payable/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/account-payable/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/ar/")){
      if(url == "/main/ar/customer_list"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account-receivable/danh-muc-khach-hang','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/accounts-receivable/set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/accounts-receivable/set-up','_blank')
        }
      }
      else if(url == "/main/ar/ar_invoice"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account-receivable/khoan-phai-thu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/accounts-receivable/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/accounts-receivable/input','_blank')
        }
      }
      else if(url == "/main/ar/release_batches"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account-receivable/xu-ly-nhieu-chung-tu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/accounts-receivable/process','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/accounts-receivable/process','_blank')
        }
      }
      else if(url == "/main/ar/ar_inquiry"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account-receivable/chi-tiet-hach-toan-khoan-phai-thu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/accounts-receivable/inquiry','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/accounts-receivable/inquiry','_blank')
        }
      }
      else if(url.includes("/main/ar/report_ar")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/account-receivable/bao-cao-reports','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/accounts-receivable/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/accounts-receivable/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/ca/")){
      if(url == "/main/ca/department" || url == "/main/ca/position_list" || url == "/main/ca/employee"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-cai-dat','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/cash-management/setup','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/cash-management/setup','_blank')
        }
      }
      else if(url == "/main/ca/ca_payment" || url == "/main/ca/ca_receipt" || url == "/main/ca/bank_payment" || url == "/main/ca/bank_receipt"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/cash-management/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/cash-management/input','_blank')
        }
      }
      else if(url == "/main/ca/release_batches" || url == "/main/ca/diff_exchange_rates"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/cash-management/report','_blank')
        }
        else{
          window.open('','_blank')
        }
      }
      else if(url == "/main/ca/ca_inquiry"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-truy-van','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/cash-management/undefined','_blank')
        }
        else{
          window.open('','_blank')
        }
      }
      else if(url.includes("/main/ca/report_ca")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tien-mat-voi-module-ke-toan-tien-mat-ca/phan-he-bao-cao','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/cash-management/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/cash-management/report','_blank')
        }
      }
    }
    else if(url.includes("/main/fa/")){
      if(url == "/main/fa/fa_group" || url == "/main/fa/fa_asset" || url == "/main/fa/dis_cost_list"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/cai-dat','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/fixed-assets-and-expenses-management/set-up','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/fixed-assets-and-expenses-management/set-up','_blank')
        }
      }
      else if(url == "/main/fa/fa_disposal" || url == "/main/fa/fa_revalue"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/fixed-assets-and-expenses-management/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/fixed-assets-and-expenses-management/input','_blank')
        }
      }
      else if(url == "/main/fa/fa_caldep" || url == "/main/fa/cal_allocation"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/fixed-assets-and-expenses-management/process','_blank')
        }
        else{
          window.open('','_blank')
        }
      }
      else if(url == "/main/fa/fa_inquiry"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/thong-tin-tai-san','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/fixed-assets-and-expenses-management/inquiry','_blank')
        }
        else{
          window.open('','_blank')
        }
      }
      else if(url.includes("/main/fa/report_fa")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-tai-san-co-dinh-va-chi-phi/bao-cao','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/fixed-assets-and-expenses-management/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/fixed-assets-and-expenses-management/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/inventory/")){
      if(url == "/main/inventory/category" || url == "/main/inventory/ic_class" || url == "/main/inventory/ic_site" ||
          url == "/main/inventory/ic_item" || url == "/main/inventory/ic_unit" || url == "/main/inventory/in_begin_balance" || url == "/main/inventory/update_inv_infor"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/cai-dat','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/inventory-management/setup','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/inventory-management/setup','_blank')
        }
      }
      else if(url == "/main/inventory/icrecr1" || url == "/main/inventory/icrecr2" || url == "/main/inventory/icrecr3" ||
        url == "/main/inventory/icrecr4" || url == "/main/inventory/icissues1" || url == "/main/inventory/icissues2" || 
        url == "/main/inventory/icissues3" || url == "/main/inventory/icissues4" || url == "/main/inventory/icadjustment"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/inventory-management/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/inventory-management/input','_blank')
        }
      }
      else if(url.includes("/main/inventory/process_inventory")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/inventory-management/processing','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/inventory-management/processing','_blank')
        }
      }
      else if(url.includes("/main/inventory/report_in")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/quan-ly-hang-ton-kho-voi-inventory/bao-cao','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/inventory-management/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/inventory-management/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/sa/")){
      if(url == "/main/sa/invoice" || url == "/main/sa/cancelinvoice" || url == "/main/sa/lostbadinvoice"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-ban-hang/phan-he-cai-dat','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/tax-invoice/setup','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/tax-invoice/setup','_blank')
        }
      }
      else if(url == "/main/sa/xuatkho_vcnb" || url == "/main/sa/listinvoice" || url == "/main/sa/check_invoice"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-ban-hang/nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/tax-invoice/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/tax-invoice/input','_blank')
        }
      }
      else if(url.includes("/main/sa/report_sa")){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-ban-hang/bao-cao','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/tax-invoice/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/tax-invoice/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/so/")){
      if(url == "/main/so/sale_order"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-hang-ban/nhap-lieu-don-dat-hang','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/sale-order/input-sale-order','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/sale-order/input-sale-order','_blank')
        }
      }
      else if(url == "/main/so/releasebatches" || url == "/main/so/approvedbatches"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-hang-ban/xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/sale-order/process','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/sale-order/process','_blank')
        }
      }
      else if(url == "/main/so/rpt_saleorder"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-hang-ban/bao-cao-dat-hang','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/sale-order/sale-order-report','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/sale-order/sale-order-report','_blank')
        }
      }
    }
    else if(url.includes("/main/po/")){
      if(url == "/main/po/purchase_order"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-mua/nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/purchase-order/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/purchase-order/input','_blank')
        }
      }
      else if(url == "/main/po/po_releasebatches" || url == "/main/po/approvedbatches"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-mua/xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/purchase-order/process','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/purchase-order/process','_blank')
        }
      }
      else if(url == "/main/po/rpt_puchaseorder"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/dat-mua/bao-cao','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/purchase-order/reports','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/purchase-order/reports','_blank')
        }
      }
    }
    else if(url.includes("/main/ei/")){
      if(url == "/main/ei/service_provider" || url == "/main/ei/service_account" || url == "/main/ei/user_account" || url == "/main/ei/serial_registration"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/cai-dat','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/e-invoice/setup','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/e-invoice/setup','_blank')
        }
      }
      else if(url == "/main/ei/ei_input"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/nhap-lieu','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/e-invoice/input','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/e-invoice/input','_blank')
        }
      }
      else if(url == "/main/ei/invoice_publishing" || url == "/main/ei/invoice_tracking"){
        if(language == "VN"){
          window.open('https://docs.ssaudit.com/hoa-don-die-n-tu/xu-ly','_blank')
        }
        else if(language == "KR"){
          window.open('https://docs.ssaudit.com/v/korean-2/e-invoice/processing','_blank')
        }
        else{
          window.open('https://docs.ssaudit.com/v/english-2/e-invoice/processing','_blank')
        }
      }
    }
    else if(url.includes("/main/general/") && url != "main/general/double_vouchers"){
      if(language == "VN"){
        window.open('https://docs.ssaudit.com/thong-tin-chung/nhap-lieu','_blank')
      }
      else if(language == "KR"){
        window.open('https://docs.ssaudit.com/v/korean-2/shared-informations/input','_blank')
      }
      else{
        window.open('https://docs.ssaudit.com/v/english-2/shared-informations/input','_blank')
      }
    }
    else if(url.includes("/main/use_full/") || url == "main/general/double_vouchers"){
      if(language == "VN"){
        window.open('https://docs.ssaudit.com/tie-n-ich/tien-ich','_blank')
      }
      else if(language == "KR"){
        window.open('https://docs.ssaudit.com/v/korean-2/usefull/usefull','_blank')
      }
      else{
        window.open('https://docs.ssaudit.com/v/english-2/useful/usefull','_blank')
      }
    }
    else if(url.includes("/main/setup_tools/")){
      if(language == "VN"){
        window.open('https://docs.ssaudit.com/ca-i-da-t-chung/bao-mat','_blank')
      }
      else if(language == "KR"){
        window.open('https://docs.ssaudit.com/v/korean-2/setup-tool/security','_blank')
      }
      else{
        window.open('https://docs.ssaudit.com/v/english-2/setup-tool/security','_blank')
      }
    }
    else if(url.includes("/main/bg/")){
      
    }
    else if(url.includes("/main/sp/")){
      
    }
  }
}
